import { Pagination } from 'antd';
import clsx from 'clsx';
import { mobilePaginationAntdWrapperClass } from '../../utils/mobileResponsiveTable';

interface MobileResponsivePaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
  className?: string;
}

export default function MobileResponsivePagination({
  current,
  total,
  pageSize,
  onChange,
  className,
}: MobileResponsivePaginationProps) {
  return (
    <div className={clsx('mt-3', mobilePaginationAntdWrapperClass, className)}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        showSizeChanger={false}
        showLessItems
        size="small"
        responsive
        onChange={onChange}
      />
    </div>
  );
}
